import { Switch } from "@design-system/Inputs/Switch";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Box } from "@design-system/Layout/Box";
import { FlexCol } from "@design-system/Layout/Flex";
import { HeaderFilter } from "@design-system/Table";
import { type FC } from "react";
import { useSupplierQuestionnaireNames } from "../../data";
import { useSupplierTableTranslations } from "./i18n";

export const QuestionnaireMultiSelect: FC<{
    selectedQuestionnaireIds?: string[];
    onQuestionnaireIdsChange: (questionnaireIds: string[]) => void;
    noQuestionnaireOnly: boolean;
    onNoQuestionnaireOnlyChange: (noQuestionnaireOnly: boolean) => void;
}> = ({
    selectedQuestionnaireIds,
    onQuestionnaireIdsChange,
    noQuestionnaireOnly,
    onNoQuestionnaireOnlyChange,
}) => {
    const { supplierQuestionnaireNames } = useSupplierQuestionnaireNames();

    const active = !!selectedQuestionnaireIds?.length || noQuestionnaireOnly;

    const handleNoQuestionnaireOnlyChange = () => {
        onQuestionnaireIdsChange([]);
        onNoQuestionnaireOnlyChange(!noQuestionnaireOnly);
    };

    const handleQuestionnaireIdsChange = (questionnaireIds: string[]) => {
        onQuestionnaireIdsChange(questionnaireIds);
        onNoQuestionnaireOnlyChange(false);
    };

    const { t, keys } = useSupplierTableTranslations();

    return (
        <Dropdown
            selectType="multi"
            value={selectedQuestionnaireIds}
            onValueChange={handleQuestionnaireIdsChange}
            closeOnValueChange={false}
        >
            <Dropdown.Trigger className="w-full h-full">
                <HeaderFilter active={active}>
                    {t(keys.lastQuestionnaire, {
                        context: active && "active",
                        count: active
                            ? selectedQuestionnaireIds?.length || 1
                            : undefined,
                    })}
                </HeaderFilter>
            </Dropdown.Trigger>
            <Dropdown.Content hasPortal>
                <Box className="border-b border-b-secondary pb-1">
                    <Dropdown.Item onClick={handleNoQuestionnaireOnlyChange}>
                        <Dropdown.ItemText>
                            {t(keys.noQuestionnaireOnly)}
                        </Dropdown.ItemText>
                        <Switch
                            checked={!!noQuestionnaireOnly}
                            onChange={handleNoQuestionnaireOnlyChange}
                        />
                    </Dropdown.Item>
                </Box>
                <FlexCol className="max-h-[300px] overflow-y-auto">
                    {supplierQuestionnaireNames.map((questionnaire) => (
                        <Dropdown.SelectableItem
                            key={questionnaire}
                            value={questionnaire}
                        >
                            <Dropdown.Checkbox />
                            <Dropdown.ItemText>
                                {questionnaire}
                            </Dropdown.ItemText>
                        </Dropdown.SelectableItem>
                    ))}
                </FlexCol>
            </Dropdown.Content>
        </Dropdown>
    );
};
